<template>
  <div class="lock">
    <div class="list">

    <ListPageLayout :loading="tableLoading">
      <el-table
                ref="table"
                border
                :data="tableListData.rows"
                height="100%"
                :header-cell-style="tableHeaderStyle"
                :cell-style="styleObj"
                v-if="tableListData.rows && tableListData.rows.length > 0"
              >
                <el-table-column label="锁记录号" prop="lockId"></el-table-column>
                <!-- <el-table-column label="车位号" prop="attr7"></el-table-column> -->
                <el-table-column label="网关编号" prop="gatewayId"></el-table-column>
                <el-table-column
                  label="最后通讯时间"
                  prop="finalTime"
                ></el-table-column>
                <!-- <el-table-column label="设备版本" prop="lockVersions">
                  </el-table-column> -->
                <el-table-column label="设备编号" prop="lockSn"> </el-table-column>
                <el-table-column label="设备状态" prop="lockStatus"></el-table-column>
                <el-table-column label="最后通信时间" prop="finalTime">
                </el-table-column>
                <el-table-column label="信号强度" prop="rssi"> </el-table-column>
                <el-table-column label="电量" prop="voltage"> </el-table-column>
                <el-table-column label="车位状态" prop="parkingSpaceStatus">
                </el-table-column>
                <!-- <el-table-column label="升锁设置" prop=""> </el-table-column> -->
                <!-- <el-table-column label="心跳时间" prop=""> </el-table-column> -->
                <el-table-column label="告警" prop="alarm"> </el-table-column>
                <!-- <el-table-column label="异常"> </el-table-column> -->
                <el-table-column label="操作" width="200px">
                  <template slot-scope="scope">
                    <button
                      class="edit"
                      type="button"
                      @click="addOrEdit(scope.row.lockId)"
                    >
                      修改
                    </button>
                    <button
                      class="delete"
                      @click="del(scope.row.lockId)"
                      type="button"
                    >
                      删除
                    </button>
                    <el-dropdown @command="handleCommand">
                      <span
                        style="
                          font-size: 12px;
                          color: #409eff;
                          margin-left: 4px;
                          cursor: pointer;
                        "
                      >
                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :disabled="scope.row.lockStatus == '00'"
                          :command="{ type: 'up', ...scope.row }"
                          >升锁</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="scope.row.lockStatus == '11'"
                          :command="{ type: 'down', ...scope.row }"
                          >降锁</el-dropdown-item
                        >
                        <el-dropdown-item :command="{ type: 'reset', ...scope.row }"
                          >重启</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-else
                style="
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <el-empty description="请先选择左侧的停车场"></el-empty>
              </div>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
    </div>
        <div class="pagination-wrapper">
      
        </div>
   
        <!--添加/修改地磁-->
        <el-dialog
          ref="park"
          title="修改地磁"
          :close-on-click-modal="false"
          :lock-scroll="false"
          :visible.sync="dialogFormVisible"
          width="430px"
          @open="openDialog"
          @close="closeDialog"
          class="dialog-lock"
        >
          <el-form
            :model="editOrAddForm"
            :rules="editOrAddFormRules"
            ref="editOrAddFormV"
          >
            <!-- <el-form-item
              label="所属车场"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.parkingId" @change="onParkChange">
                  <el-option
                    v-for="item in shareParksData"
                    :key="item.parkingId"
                    :value="item.parkingId"
                    :label="item.parkingName"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item> -->
            <!-- <el-form-item
              label="所属网关"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.gatewayId">
                  <el-option
                    v-for="item in gateways"
                    :key="item.gatewayId"
                    :value="item.gatewayId"
                    :label="item.gatewaySn"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item> -->
            <el-form-item
              label="锁编号"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-input v-model="editOrAddForm.lockSn"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item
              label="告警声音"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.alarm">
                  <el-option
                    v-for="[key, value] in Object.entries(lockAlarm)"
                    :key="key"
                    :value="key"
                    :label="value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="挡臂阻尼"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.forarmBlock">
                  <el-option
                    v-for="[key, value] in Object.entries(lockForarmBlock)"
                    :key="key"
                    :value="key"
                    :label="value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="发射功率"
              :label-width="formLabelWidth"
              prop="devNum"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.power">
                  <el-option
                    v-for="[key, value] in Object.entries(lockPower)"
                    :key="key"
                    :value="key"
                    :label="value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <!-- <el-form-item
                label="升锁设置"
                :label-width="formLabelWidth"
                prop="devNum"
              >
                <el-col :span="18">
                  <el-select v-model="editOrAddForm.alarm">
                    <el-option
                      v-for="[key, value] in Object.entries(lockTime)"
                      :key="key"
                      :value="key"
                      :label="value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item> -->
            <!-- <el-form-item
                label="心跳时间"
                :label-width="formLabelWidth"
                prop="devNum"
              >
                <el-col :span="18">
                  <el-select v-model="editOrAddForm.alarm">
                    <el-option
                      v-for="[key, value] in Object.entries(lockHeartbeat)"
                      :key="key"
                      :value="key"
                      :label="value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  shareParks,
  locks,
  lockDetail,
  addLock,
  updateLock,
  deleteLock,
  upLock,
  downLock,
  resetLock,
  gatewaysByParkingId,
} from "@/api/url";

import Page from "@/page/commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";

export default {
  props: ["parkingId", "gatewayId"],
  data() {
    return {
      lockAlarm: { ...LOCK_ALARM },
      lockForarmBlock: { ...LOCK_FORARM_BLOCK },
      lockPower: { ...LOCK_POWER },
      lockTime: { ...LOCK_TIME },
      lockHeartbeat: { ...LOCK_HEARTBEAT },
      dialogFormVisible: false,

      park: "",

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      editOrAddForm: {
        //   parkingId: undefined,
        gatewayId: "",
        lockSn: "",
        alarm: "",
        forarmBlock: "",
        power: "",
      },

      editOrAddFormRules: {},
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devNum: "",
        //transNum:'',
        //startTime:"",
        //endTime:""
      },
      downloadFileds: {
        地磁编号: "onerankdevDevSn",
        网关编号: {
          field: "attr7",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).stationSn
              : "";
          },
        },
        泊位编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).spaceNum
              : "";
          },
        },
        停车道路: {
          field: "attr2",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "attr3",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        最后通讯时间: "lastFlowDate",
        地磁状态: "attr1",
        通信频率: "loraid",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      shareParksData: [],
      gateways: [],
      tableLoading: false,
    };
  },
  mounted(){
    console.log('list mounted')
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    params() {
        
        return {
          parkingId: this.parkingId,
          gatewayId: this.gatewayId,
        };
      }
  },
  
  
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.tableListData.rows = []
        const { parkingId, gatewayId } = newVal;
        console.log("list newVal", newVal);
        if (!parkingId) return;
        // if(!gatewayId) return ;
        this.search.pageNumber = 1;
        this.tableList(1);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
        console.log("list", curPage);
      var _this = this;
      _this.tableListData.rows = [];
      _this.tableLoading = true;
      this.$postRequest(locks(), {
        limit: this.search.pageSize,
        page: curPage,
        parkingId: this.parkingId,
        gatewayId: this.gatewayId,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          console.log(data.data.rows);
          _this.tableListData.rows = data.data.rows;
        })
        .finally(() => {
          _this.tableLoading = false;
        });
    },

    addOrEdit(id) {
      this.dialogFormVisible = true;
      this.$get(`${lockDetail()}/${id}`).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.editOrAddForm = data?.data ?? {};
      });
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          console.log("_this.addAndEditForm=>", _this.addAndEditForm);

          _this
            .$putRequest(updateLock(), {
              ..._this.editOrAddForm,
            })
            .then((data) => {
              if (data.status !== 200)
                return _this.$message.error(data.message);
              _this.$notify({
                type: "success",
                message: "修改成功！",
                title: "成功",
              });
              _this.tableList(_this.curIndex);
            });
        }
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(`${deleteLock()}/${id}`).then((data) => {
            if (data.status != 200) return _this.$message.error(data.message);

            _this.$notify({
              type: "success",
              message: "删除成功！",
              title: "成功",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    //   handleTreeClick: function(node) {
    //     // 如果节点类型为停车场
    //     if (node.type === "parking") {
    //       this.search.parkingId = node.id;
    //       this.onParkChange(node.id);
    //       // 获取数据
    //       this.tableList(this.search.pageNumber);
    //     } else this.search.parkingId = undefined;
    //   },
    //   searchList: function() {
    //     if (this.tableLoading) return;
    //     if (!this.search.parkingId)
    //       return this.$message({ type: "error", message: "请先选择停车场" });
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   },

    //   getShareParks() {
    //     this.search.gatewayId = "";
    //     this.editOrAddForm.gatewayId = "";
    //     this.$postRequest(shareParks(), {}).then((data) => {
    //       this.shareParksData = data?.data?.data?.rows ?? [];
    //     });
    //   },
    async handleCommand(command) {
      console.log("command=>", command);
      const { type, gatewayId, lockId } = command;
      switch (type) {
        case "up": {
          const res = await this.$putRequest(upLock(), {
            gatewayIds: gatewayId,
            lockIds: lockId,
          });
          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }

        case "down": {
          const res = await this.$putRequest(downLock(), {
            gatewayIds: gatewayId,
            lockIds: lockId,
          });
          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }
        case "reset": {
          const res = await this.$putRequest(resetLock(), {
            gatewayIds: gatewayId,
            lockIds: lockId,
          });

          if (res.status === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.tableList(this.curIndex);
          } else {
            this.$message.error(res.message);
          }
          break;
        }
      }
    },
    //   getGateways(id) {
    //     this.$get(`${gatewaysByParkingId()}/${id}`).then((data) => {
    //       this.gateways = data?.data ?? [];
    //     });
    //   },
    //   onParkChange(val) {
    //     this.getGateways(val);
    //   },
  },
 

  components: {
    ListPageLayout,
    Page,
    AreaTree,
  },
 
 
};
</script>

<style scoped>
/* @import '@/assets/css/equip.css'; */
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
  position: relative;
}

.lock {
  position: relative;
  width: 100%;
}

.list {
  position: relative;
  padding-bottom: 100px !important; /* 为分页组件留出空间 */
  box-sizing: border-box;
}

.pagination-wrapper {
  position: absolute;
  bottom: 10px;
  right: 20px;
  background: white;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
.lock .form-control {
  height: 26px;
}
</style>
<style>
.lock .dialog-lock .el-select {
  display: block;
}
</style>
